module.exports = __webpack_public_path__ + "static/media/roll-dice-30.49e73d13.png";